var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Validator } from "jsonschema";
export function getSchema(version) {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield import(`../form-schemas/${version}/form-spec.json`))
            .default;
    });
}
export function getResponseSchema(version) {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield import(`../form-schemas/${version}/response-spec.json`))
            .default;
    });
}
export function isValidSpec(formSchema, formSpec) {
    const v = new Validator();
    v.validate(formSpec, formSchema, {
        throwError: true,
    });
    return true;
}
export function isValidResponse(responseSchema, response) {
    const v = new Validator();
    let result = v.validate(response, responseSchema);
    return result.valid;
}
